var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 25 24",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.561 11.22A4.46 4.46 0 0 0 18.5 8.5C18.5 6.019 16.481 4 14 4H6.5v15h8c2.481 0 4.5-2.019 4.5-4.5a4.48 4.48 0 0 0-1.439-3.28M14 7c.827 0 1.5.673 1.5 1.5S14.827 10 14 10H9.5V7zm.5 9h-5v-3h5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5"
  })));
};
export default SvgBold;